
import { abstractdescriptions as abstractDescriptionsAbstract, abstractcontext as abstractContextAbstract } from '../../Projects/Config/artprintsabstractdata';
import { abstractdescriptions as abstractDescriptionsExclusive, abstractcontext as abstractContextExclusive } from '../../Projects/Config/artprintsexclusivedata';
import { abstractdescriptions as abstractDescriptionsLandscape, abstractcontext as abstractContextLandscape } from '../../Projects/Config/artprintslandscapedata';
import { abstractdescriptions as abstractDescriptionsDecorative, abstractcontext as abstractContextDecorative } from '../../Projects/Config/artprintsdecorativedata';
import { abstractdescriptions as abstractDescriptionsSt, abstractcontext as abstractContextSt } from '../../Projects/Config/artprintsstdata';

const AWS_BASE_URLS = {
  Exclusive: "https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/Exclusive",
  Landscape: "https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/Landscape",
  Abstract: "https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/Abstract",
  Decorative: "https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/Decorative",
  St: "https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/set+of+2+and+3"
};

const getImageUrl = (category, imageNumber, useParentheses = false) => {
  const baseUrl = AWS_BASE_URLS[category];
  const formattedNum = useParentheses ? `(${imageNumber})` : `${imageNumber}`;
  
  return {
    jpg: `${baseUrl}/${formattedNum}.jpg`,
    jpeg: `${baseUrl}/${formattedNum}.jpeg`
  };
};

function mulberry32(seed) {
  return function () {
    let t = (seed += 0x6D2B79F5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function seededShuffle(array, seed = 123456) {
  const rng = mulberry32(seed);
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

const totalExclusive = 450;
const totalLandscape = 138;
const totalAbstract = 369;
const totalDecorative = 388;
const totalSt = 182;

// 1. Exclusive Set
const exclusiveSet = Array.from({ length: totalExclusive }, (_, index) => {
  const imgNum = index + 1;
  const imageUrls = getImageUrl('Exclusive', imgNum, true);
  return {
    Img: imageUrls.jpg,
    ImgJpg: imageUrls.jpg,
    ImgJpeg: imageUrls.jpeg, 
    title: `#EX${String(index + 101).padStart(3, '0')}`,
    desc: abstractDescriptionsExclusive[index] || "Default description",
    context: abstractContextExclusive[index] || "Default context",
    btn: 'View Detail',
  };
});

const landscapeSet = Array.from({ length: totalLandscape }, (_, index) => {
  const imgNum = index + 1;
  const imageUrls = getImageUrl('Landscape', imgNum, false);
  return {
    Img: imageUrls.jpg,
    ImgJpg: imageUrls.jpg,
    ImgJpeg: imageUrls.jpeg,
    title: `#LS${String(imgNum).padStart(3, '0')}`,
    desc: abstractDescriptionsLandscape[index] || "Default description",
    context: abstractContextLandscape[index] || "Default context",
    btn: 'View Detail',
  };
});

const abstractSet = Array.from({ length: totalAbstract }, (_, index) => {
  const imgNum = index + 1;
  const imageUrls = getImageUrl('Abstract', imgNum, true);
  return {
    Img: imageUrls.jpg,
    ImgJpg: imageUrls.jpg,
    ImgJpeg: imageUrls.jpeg,
    title: `#AB${String(index + 101).padStart(3, '0')}`,
    desc: abstractDescriptionsAbstract[index] || "Default description",
    context: abstractContextAbstract[index] || "Default context",
    btn: 'View Detail',
  };
});

const decorativeSet = Array.from({ length: totalDecorative }, (_, index) => {
  const imgNum = index + 1;
  const imageUrls = getImageUrl('Decorative', imgNum, true);
  return {
    Img: imageUrls.jpg,
    ImgJpg: imageUrls.jpg,
    ImgJpeg: imageUrls.jpeg,
    title: `#DC${String(index + 101).padStart(3, '0')}`,
    desc: abstractDescriptionsDecorative[index] || "Default description",
    context: abstractContextDecorative[index] || "Default context",
    btn: 'View Detail',
  };
});

const stSet = Array.from({ length: totalSt }, (_, index) => {
  const imgNum = index + 1;
  const imageUrls = getImageUrl('St', imgNum, true);
  return {
    Img: imageUrls.jpg,
    ImgJpg: imageUrls.jpg,
    ImgJpeg: imageUrls.jpeg,
    title: `#ST${String(index + 101).padStart(3, '0')}`,
    desc: abstractDescriptionsSt[index] || "Default description",
    context: abstractContextSt[index] || "Default context",
    btn: 'View Detail',
  };
});

const combinedData = [...exclusiveSet, ...landscapeSet, ...abstractSet, ...decorativeSet, ...stSet];

export const walldata = seededShuffle(combinedData, 42);
